import { Box, Button } from "@mui/material";
import { styled } from "@mui/system";
import { Colors } from "../theme";


export const InstructionBar = styled(Box)(({ theme }) => ({
  "&.instruction-container": {
    position: "fixed",
    top: "80px", // space for header
    right: "20px",
    zIndex: 1000,
    maxWidth: "320px",
    transition: "all 0.3s ease-in-out",
  },

  ".instruction-banner": {
    backgroundColor: Colors.white,
    color: "#424242",
    padding: "16px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e0e0e0",
    fontSize: "16px",
    lineHeight: "1.6",
    fontFamily: "inherit",

    "& .heading": {
      fontWeight: 600,
      marginBottom: "8px",
      color: "#212121",
    },
  },

  ".info-icon": {
    backgroundcolor: Colors.text,
    padding: "10px",
    borderRadius: "50%",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease-in-out, transform 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#f0f0f0",
      transform: "scale(1.05)",
    },
  },
}));


export const AddModuleWrapper = styled(Box)(({ theme }) => ({
  padding: "0px 20px 20px 20px",
  "& .font14": {
    fontSize: "14px",
  },
  "& .font12": {
    fontSize: "12px",
  },
  "& .save-container": {
    marginTop: "10px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    position: "sticky",
    bottom: 0,
    backgroundColor: Colors.white,
    zIndex: 10,
    padding: "10px 0",
  },

  "& .header-section": {
    padding: "10px 0 10px 0",
    backgroundcolor: Colors.text,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",

    "& h5": {
      fontWeight: 500,
      position: "relative",

      "&::after": {
        content: '""',
        position: "absolute",
        left: 0,
        bottom: "-5px",
        backgroundColor: "#e0e0e0",
        height: "1px",
        width: "100%",
      },
    },
  },

  "& .course-container": {
    padding: "25px 20px",

    "& .course-title": {
      marginBottom: "10px",
      fontWeight: 500,
    },
  },

  "& .empty-module-message": {
    padding: "10px 0",
    color: "#757575",
    fontStyle: "italic",
  },

  "& .empty-message": {
    color: "#757575",
    fontStyle: "italic",
    marginTop: "5px",
    marginBottom: "10px",
  },
}));

export const ModuleContainer = styled(Box)(({ theme }) => ({
  "& textarea ,input": {
    border: "1px solid #ccc",
    borderRadius: "4px",
    font: "inherit",
  },
  "& .module-accordion": {
    marginBottom: "10px",
    borderLeft: "2px solid #0da2ff",

    "& .module-header": {
      borderBottom: "1px solid #0da2ff",

      "& .module-index": {
        fontWeight: 500,
        marginRight: "5px",
      },
    },
    "& .MuiCollapse-wrapper":{
      marginBottom:"10px"
    },
    "& .flex-input": {
      display: "flex",
      gap: "10px",
      "@media (max-width: 768px)": {
        flexDirection: "column",
        gap: "10px",
      },
    },

    "& .module-content": {
      width: "100%",
      display: "flex",
      gap: "20px",

      "@media (max-width: 1136px)": {
        flexDirection: "column",
        gap: "0px",
      },
    },

    "& .field-label": {
      fontWeight: 500,
      marginBottom: "5px",
    },

    "& .module-input, & .submodule-input": {
      height: "40px",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      minWidth: "250px",

      "& textarea": {
        resize: "",
      },
    },

    "& .section-title": {
      fontWeight: 500,
      marginBottom: "10px",
      marginTop: "10px",
    },

    "& .submodule-section": {
      marginTop: "10px",
      marginBottom: "10px",
    },

    "& .submodule-accordion": {
      marginBottom: "10px",
      borderLeft: "2px solid #cc0001",

      "& .submodule-header": {
        borderBottom: "1px solid #cc0001",
      },

      "& .submodule-details": {
        padding: "20px 16px",
        flexDirection: "column",
        "& .submodule-content": {
          display: "flex",
          gap:"20px",
          "@media (max-width: 1115px)": {
            flexDirection: "column",
            gap: "0px",
          },
        },
      },
    },

    "& .materials-section": {
      marginTop: "20px",
      marginBottom: "15px",
    },

    "& .file-list": {
      border: "1px solid #e0e0e0",
      borderRadius: "4px",
      padding: "5px 0",
      margin: "10px 0",
    },

    "& .file-item": {
      borderBottom: "1px solid #f5f5f5",

      "&:last-child": {
        borderBottom: "none",
      },
    },

    "& .file-upload": {
      marginTop: "15px",
      marginBottom: "15px",
    },

    "& .actions": {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "10px",
    },

    "& .module-actions , .submodule-action": {
      display: "flex",

      alignItems: "center",

      marginTop: "17px",
      gap: "20px",
    },

    "& .delete-btn, & .delete-module-btn": {
      color: "#f44336",
    },
  },
  "& .action_button ":{
    display:"flex",
    gap:"10px",
  },
  "& .options-title":{
    marginTop:"15px"
  }
}));

export const StyledButton = styled(Button)({
  backgroundColor: "#f5f5f5",
  color: "#424242",
  textTransform: "none",
  padding: "8px 15px",
  display: "flex",
  alignItems: "center",
  gap: "5px",
  border: "1px solid #e0e0e0",
  marginTop: "5px",
  marginBottom: "10px",
  boxShadow: "none",
  width:"fit-content",

  "&:hover": {
    backgroundColor: "#e0e0e0",
    boxShadow: "none",
  },

  "&.submodule-btn": {
    "& svg": {
      color: "#cc0001",
    },
  },

  "&.upload-btn": {
    "& svg": {
      color: "#4caf50",
    },
  },
});
